import React, { useState } from "react";
import { ImPlus } from "react-icons/im";
import { NavLink } from "react-router-dom";
import NavTitle from "./NavTitle";

const Category = () => {
  const [showSubCatOne, setShowSubCatOne] = useState(false);

  const items = [
    { _id: 990, title: "Fans Pricelist", link: "/pricelist/fansprice" },
    { _id: 991, title: "Ac Pricelist", link: "/pricelist/acprice" },
    { _id: 992, title: "Gesyser Pricelist", link: "/pricelist/geyserprice" },
    { _id: 993, title: "Refrigerator Pricelist", link: "/pricelist/refrigeratorprice" },
    { _id: 994, title: "Dispenser Pricelist", link: "/pricelist/dispenserprice" },
    { _id: 994, title: "All Pricelist", link: "/pricelist/pricelist" },
  ];

  return (
    <div className="w-full">
      <NavTitle title="Product Price List" icons={false} />
      <div>
        <ul className="flex flex-col gap-4 text-sm lg:text-base text-[#767676]">
          {items.map(({ _id, title, icons, link }) => (
            <li
              key={_id}
              className="border-b-[1px] border-b-[#F0F0F0] pb-2 flex items-center justify-between"
            >
              <NavLink
                to={link} 
                className="hover:text-primeColor duration-300 w-full flex justify-between items-center"
              >
                {title}
                {icons && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowSubCatOne(!showSubCatOne);
                    }}
                    className="text-[10px] lg:text-xs text-gray-400 hover:text-primeColor duration-300"
                  >
                    <ImPlus />
                  </span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Category;
